// export enum ErrorType {
//     InsufficientBalance = "Insufficient balance.",
//     SessionExpired = "Your session is expired, please sign in again.",
//     Disconnected = "An error has occurred. Please try again later.",
//     SystemError = "SystemError has occurred. Please try again later.",
// }

export enum ErrorType {
  InsufficientBalance = 'error_popup_insufficient_balance',
  SessionExpired = 'error_popup_session_expired',
  Disconnected = 'error_popup_disconnected',
  SignalRDisconnected = 'error_popup_signalr_disconnected',
  SystemError = 'error_popup_system_error',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  UnknownSystemError = 'error_popup_system_error',
  Reconnecting = 'error_popup_reconnecting',
  OverPlayerMaxLose = 'error_popup_over_player_max_lose',
  OverMaxBet = 'error_popup_over_max_bet',
  LowerThanMinBet = 'error_popup_lower_than_min_bet',
  BetNotFound = 'error_popup_bet_not_found',
  BetExisted = 'error_popup_bet_existed',
  SpecialRule = 'uncommon_special_rules', // if errorType is this, it will be handled in the respective game
  OverTableMaxBet = 'error_popup_over_table_max',
  LowerThanTableMinBet = 'error_popup_lower_than_table_min',
  BetOpposite = 'error_popup_bet_opposite', // 雙邊下注
  InvalidGameState = 'error_popup_invalid_game_state', // wait for next round
  VoucherError = 'error_popup_voucher_error',
}
